export default "__VITE_ASSET__B3TH74xJ__"